import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const Separator = () => /*#__PURE__*/_jsx(Text, {
  marginInline: "100",
  as: "span",
  children: '•'
});
Separator.displayName = 'Separator';
export default Separator;